import _get from 'lodash/get';

export default function hydrateVErrors(Exception) {
  let errors = null;
  try {
    let vErrors = _get(Exception, 'response.data.errors');

    if (vErrors) {
      errors = Object.keys(vErrors).map(i => ({
        field: i,
        error: vErrors[i][0],
      }));
    }
  } catch (e) {}

  return errors;
}
